module.exports = __webpack_public_path__ + "static/media/deadline_red.2ee88972.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/deadline_red.svg
// module id = 131
// module chunks = 0